import ASelectFieldUserStatus from './index.vue';

ASelectFieldUserStatus.install = app => {
  app.component(ASelectFieldUserStatus.name, ASelectFieldUserStatus);
};

export default ASelectFieldUserStatus;
